/**
 * @generated SignedSource<<4bc489d025f3bed0095e9a8fb4505382>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SeriesExplorerNextNoteMutation$variables = {
  id: string;
  withEvent?: boolean | null;
};
export type SeriesExplorerNextNoteMutation$data = {
  readonly NoteStream_CreateNextNote: {
    readonly noteEdge: {
      readonly cursor: string;
      readonly node: {
        readonly url: string | null;
      } | null;
    };
  } | null;
};
export type SeriesExplorerNextNoteMutation = {
  response: SeriesExplorerNextNoteMutation$data;
  variables: SeriesExplorerNextNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withEvent"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "withEvent",
    "variableName": "withEvent"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SeriesExplorerNextNoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteStreamCreateNextNote",
        "kind": "LinkedField",
        "name": "NoteStream_CreateNextNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteEdge",
            "kind": "LinkedField",
            "name": "noteEdge",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SeriesExplorerNextNoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteStreamCreateNextNote",
        "kind": "LinkedField",
        "name": "NoteStream_CreateNextNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteEdge",
            "kind": "LinkedField",
            "name": "noteEdge",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "69183f0831f646e2c5e3109a573b0966",
    "id": null,
    "metadata": {},
    "name": "SeriesExplorerNextNoteMutation",
    "operationKind": "mutation",
    "text": "mutation SeriesExplorerNextNoteMutation(\n  $id: ID!\n  $withEvent: Boolean\n) {\n  NoteStream_CreateNextNote(id: $id, withEvent: $withEvent) {\n    noteEdge {\n      cursor\n      node {\n        url\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "06be89bed7b9b2162f9024f1a66ceaaa";

export default node;
